export interface ChatArchiveState {
  buttonVisible: boolean;
  screenOpen: boolean;
}

export const initialChatArchiveState: ChatArchiveState = { buttonVisible: false, screenOpen: false };

export function chatArchiveReducer(state: ChatArchiveState, action: 'reveal' | 'hide' | 'open' | 'back'): ChatArchiveState {
  switch (action) {
    case 'reveal': return state.screenOpen ? state : { ...state, buttonVisible: true };
    case 'hide': return { ...state, buttonVisible: false };
    case 'open': return { buttonVisible: false, screenOpen: true };
    case 'back': return initialChatArchiveState;
  }
}

/** Показываем кнопку только при намеренном движении вниз у верхней границы списка. */
export function shouldRevealArchive(scrollTop: number, deltaX: number, deltaY: number): boolean {
  return scrollTop <= 0 && deltaY >= 60 && deltaY > Math.abs(deltaX);
}
